import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import EstimateForm from "./EstimateForm";
import LegacyWarning from "../components/EstimateForm/LegacyWarning";
import Layout from "../components/shared/Layout";
import Loading from "../components/shared/Loading";
import { useScrollToTop } from "../hooks/use-scroll-to-top";
import { useAuth } from "../hooks/usehooks.com/use-auth";
import apiConfig from "../config/api.config";

const defaultEstimate = {
  industryName: "",
  notes: "",
  assets: [],
  newAsset: {
    name: "",
    cost: 0,
  },
};

const initialState = {
  loaded: false,
  estimate: {},
  assets: [],
};

export default function EditEstimate() {
  useScrollToTop();

  const { user } = useAuth();
  const { id } = useParams();
  const [estimateDetail, setEstimateDetail] = useState(initialState);

  const getApiConfigs = () => ({
    url: apiConfig.legacyApiUrl,
    endpoint: "estimateDetails",
    method: "GET",
  });

  useEffect(() => {
    if (!user) return;
    (async () => {
      try {
        const { url, endpoint, method } = getApiConfigs();
        const token = await user.getIdToken(true);
        const response = await fetch(`${url}/${endpoint}/${id}`, {
          method,
          headers: {
            Authorization: `Bearer ${token}`,
          },
        });
        const data = await response.json();
        setEstimateDetail({ ...data, loaded: true });
      } catch (err) {
        console.error(err);
      }
    })();
  }, [id, user]);

  return (
    <Layout>
      {!estimateDetail.loaded ? (
        <Loading />
      ) : (
        <>
          <LegacyWarning visible={true} />
          <EstimateForm
            initialEstimate={{
              assets: estimateDetail.assets,
              ...estimateDetail.estimate,
            }}
            docId={id}
            readOnly={true}
          />
        </>
      )}
    </Layout>
  );
}
